module.exports = __webpack_public_path__ + "assets/img/nav-active.e829e281.svg";